import { useContext } from 'react';
import { CreateApprovalContext } from '../components/CreateApprovalContext';

export function useCreateApprovalContext() {
    const context = useContext(CreateApprovalContext);
    if (!context) {
        throw new Error('useApprovalContext must be used within an ApprovalContext.Provider');
    }
    return context;
}
